import { FC } from "react";

type ZoomControlProps = {
  zoom: number,
  handleZoomIn: () => void;
  handleZoomOut: () => void;
};

const ZoomControl: FC<ZoomControlProps> = ({ zoom, handleZoomIn, handleZoomOut }): JSX.Element => {
  return (
    <div className="p-1 shadow-sm d-flex justify-content-center align-items-center position-relative z-1">
        <span>Zoom</span>
        &nbsp;
        <DirectionButton onClick={handleZoomOut}>
            <><i className="bi bi-zoom-out"></i></>
        </DirectionButton>
        &nbsp;
        <span className="fw-bold border rounded-2 py-1 px-2">{Math.round(Number(zoom * 100))}%</span>
        &nbsp;
        <DirectionButton onClick={handleZoomIn}>
            <><i className="bi bi-zoom-in"></i></>
        </DirectionButton>
    </div>
  );
};

export default ZoomControl;

const DirectionButton: FC<{ children: JSX.Element; onClick: () => void; }> = ({children, onClick}) => {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a className="btn btn-primary btn-sm" onClick={onClick}>{children}</a>
  );
};
